module.exports = __webpack_public_path__ + "static/img/qj.7fcc0f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qj.png
// module id = Fzqt
// module chunks = 1